import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    class: `pa-0 ${_vm.hideBorderOnCollapse ? 'hiddenBorder mb-0' : 'exp01ff mb-4'}`
  }, [_c(VExpansionPanels, {
    model: {
      value: _vm.expanded,
      callback: function ($$v) {
        _vm.expanded = $$v;
      },
      expression: "expanded"
    }
  }, [_c(VExpansionPanel, {
    class: _vm.expansionPanelsClass
  }, [_c(VExpansionPanelHeader, {
    attrs: {
      "expand-icon": _vm.expandIcon
    }
  }, [_vm._t("header", function () {
    return [_c('div', {
      staticClass: "header"
    }, [_c('div', [_c(VIcon, {
      attrs: {
        "color": _vm.color
      }
    }, [_vm._v("fal fa-calendar-alt")])], 1), _c('div', {
      staticClass: "headerDatetime"
    }, [_vm._v(_vm._s(_vm.getLocaleDateFromUnix(_vm.startDate)))]), _vm.isRange ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('Core.DateTimePicker.headerTextJoinder')))]) : _vm._e(), _vm.isRange ? _c('div', {
      staticClass: "headerDatetime"
    }, [_vm._v(_vm._s(_vm.getLocaleDateFromUnix(_vm.endDate)))]) : _vm._e()])];
  }, {
    "startDate": _vm.getLocaleDateFromUnix(_vm.startDate),
    "endDate": _vm.getLocaleDateFromUnix(_vm.endDate)
  })], 2), _c(VExpansionPanelContent, [_c(VRow, {
    staticClass: "pa-0 cols-2",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c(VForm, {
    ref: "formDatePicker",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.isDatePickerFormValid,
      callback: function ($$v) {
        _vm.isDatePickerFormValid = $$v;
      },
      expression: "isDatePickerFormValid"
    }
  }, [_c('core-date-time-picker-field', {
    ref: "inputStart",
    attrs: {
      "label": _vm.isRange ? _vm.$i18n_t('Core.DateTimePicker.startDate') : _vm.$i18n_t('Core.DateTimePicker.dateTime'),
      "value": _vm.getLocaleDateFromUnix(_vm.startDate),
      "dateValue": _vm.startDate,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.rules.date, _vm.inputValidationRules.validRangeStart],
      "firstDayOfWeek": "1"
    },
    on: {
      "date:changed": _vm.handleStartDateChange,
      "date:picked": _vm.handleStartDatePicked
    }
  }), _vm.isRange ? _c('core-date-time-picker-field', {
    ref: "inputEnd",
    attrs: {
      "label": _vm.$i18n_t('Core.DateTimePicker.endDate'),
      "value": _vm.getLocaleDateFromUnix(_vm.endDate),
      "dateValue": _vm.endDate,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.rules.date, _vm.inputValidationRules.validRangeEnd],
      "firstDayOfWeek": "1"
    },
    on: {
      "date:changed": _vm.handleEndDateChange,
      "date:picked": _vm.handleEndDatePicked
    }
  }) : _vm._e(), _c(VBtn, {
    class: `v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "disabled": !_vm.isDatePickerFormValid,
      "color": _vm.color,
      "text": "",
      "rounded": ""
    },
    on: {
      "click": _vm.handleApplyClick
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.buttonApply')) + "\n              ")])], 1)], 1), _c(VCol, [_vm.isRange ? _c('ul', {
    staticClass: "quickRangeList"
  }, [_c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesRelative')) + "\n              ")]), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}5m`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Minutes`, 5, {
    n: 5
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}15m`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Minutes`, 15, {
    n: 15
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}30m`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Minutes`, 30, {
    n: 30
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 1, {
    n: 1
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 2, {
    n: 2
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}6h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 6, {
    n: 6
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}12h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 12, {
    n: 12
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": "",
      "data-cy": "24hours_option"
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}24h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 24, {
    n: 24
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Days`, 2, {
    n: 2
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}7d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Days`, 7, {
    n: 7
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}30d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Days`, 30, {
    n: 30
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}90d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Days`, 90, {
    n: 90
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}6M`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Months`, 6, {
    n: 6
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1y`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Years`, 1, {
    n: 1
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2y`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Years`, 2, {
    n: 2
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}5y`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Years`, 5, {
    n: 5
  })) + "\n                ")])], 1), _c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesQuick')) + "\n              ")]), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1d/d');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.yesterday')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-2d/d');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.dayBeforeYesterday')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-7d/d');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisDayLastWeek')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1w/w');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousWeek')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1M/M');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousMonth')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1y/y');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousYear')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/d');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.today')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/d', true);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.todaySoFar')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/w');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisWeek')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/w', true);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisWeekSoFar')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/M');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisMonth')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/M', true);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisMonthSoFar')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/y');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisYear')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/y', true);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisYearSoFar')) + "\n                ")])], 1)]) : _vm._e(), !_vm.isRange ? _c('ul', {
    staticClass: "quickRangeList"
  }, [_c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesRelative')) + "\n              ")]), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 1, {
    n: 1
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 2, {
    n: 2
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}3h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 3, {
    n: 3
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}6h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 6, {
    n: 6
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}12h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 12, {
    n: 12
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}24h`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 24, {
    n: 24
  })) + "\n                ")])], 1), _c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesQuick')) + "\n              ")]), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/d');
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.today')) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1d/d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t(`Core.DateTimePicker.rangeItems.quick.${_vm.futureRange ? 'tomorrow' : 'yesterday'}`)) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2d/d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t(`Core.DateTimePicker.rangeItems.quick.${_vm.futureRange ? 'dayAfterTomorrow' : 'dayBeforeYesterday'}`)) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1w/d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Weeks`, 1, {
    n: 1
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1M/d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Months`, 1, {
    n: 1
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2M/d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Months`, 2, {
    n: 2
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}3M/d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Months`, 3, {
    n: 3
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}6M/d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Months`, 6, {
    n: 6
  })) + "\n                ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1y/d`);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Years`, 1, {
    n: 1
  })) + "\n                ")])], 1)]) : _vm._e()])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };